<template>
    <div class="navigation-grid limit">
        <navigationcard
            v-for="item in gridItems"
            :key="item.id"
            :url="`/${$i18n.locale}/${item.url}`"
            :inverse="item.inverse"
        >
            <template v-slot:header>{{ item.title }}</template>
            <template v-slot:content>
                <p v-html="item.body"></p>
            </template>
            <template v-slot:quote>
                <span v-html="item.subtitle"></span>
            </template>
        </navigationcard>

        <navigationcard
            :img="require('@/assets/images/data-in-computer.jpg')"
            v-if="showing[3]"
            inverse
        >
            <template v-slot:header>
                <span class="fade" :class="{'fade-in-out' : fade}">{{quotes[quoteIndex].content}}</span>
            </template>

            <template v-slot:quote>
                <span class="fade" :class="{'fade-in-out' : fade}">
                    <b>{{quotes[quoteIndex].first_name}}</b>
                    {{quotes[quoteIndex].last_name}}
                </span>
            </template>
        </navigationcard>
    </div>
</template>

<script>
import _ from "lodash";
import navigationcard from "@/components/navigationcard.vue";

export default {
    components: {
        navigationcard
    },
    data() {
        return {
            innerSize: window.innerWidth,
            fade: false,
            quotes: [
                {
                    content: `“Without big data, you are blind and deaf and in the middle of a freeway.”`,
                    first_name: "Geoffrey",
                    last_name: "Moore"
                },
                {
                    content: `“In God we trust, all others bring data.”`,
                    first_name: "W Edwards",
                    last_name: "Deming"
                },
                {
                    content: `“Data is the new oil.”`,
                    first_name: "Clive",
                    last_name: "Humby"
                },
                {
                    content: `“It is a capital mistake to theorize before one has data.”`,
                    first_name: "Sherlock",
                    last_name: "Holmes"
                },
                {
                    content: `“Without a systematic way to start and keep data clean, bad data will happen.”`,
                    first_name: "Donato",
                    last_name: "Diorio"
                },
                {
                    content: `“You can have data without information, but you cannot have information without data.”`,
                    first_name: "Daniel Keys",
                    last_name: "Moran"
                },
                {
                    content: `“Data really powers everything that we do.”`,
                    first_name: "Jeff",
                    last_name: "Weiner"
                }
            ],
            quoteIndex: 0
        };
    },
    props: ["showing"],
    mounted() {
        addEventListener("resize", () => {
            this.innerSize = window.innerWidth;
        });

        this.quoteIndex = Math.floor(Math.random() * this.quotes.length);

        this.fader();
    },
    computed: {
        isMobile() {
            if (this.innerSize < 950) {
                return true;
            } else {
                return false;
            }
        },
        gridItems: function() {
            const items = [];
            if (!this.$i18n.messages[this.$i18n.locale]) return items;

            const navigationGridItems = this.$i18n.messages[this.$i18n.locale]
                .pages.home.navigation_grid;

            for (let index = 0; index < navigationGridItems.length; index++) {
                const gridItem = navigationGridItems[index];
                if (this.showing[index]) items.push(gridItem);
            }

            items.push(
                this.$i18n.messages[this.$i18n.locale].misc
                    .contact_navigation_grid_tile
            );

            // Determine which tiles are inversed
            if (this.innerSize > 950) {
                const chunkedItems = _.chunk(items, 2);
                for (let index = 0; index < chunkedItems.length; index++) {
                    const chunk = chunkedItems[index];

                    const isOddChunk = index % 2 !== 0;

                    chunk[0].inverse = isOddChunk;
                    if (chunk[1]) chunk[1].inverse = !isOddChunk;
                }

                return _.flatten(chunkedItems);
            } else {
                for (let index = 0; index < items.length; index++) {
                    items[index].inverse = index % 2 !== 0;
                }
                return items;
            }
        }
    },
    methods: {
        fader() {
            let time = 6000;
            let timer = setInterval(() => {
                this.fade = true;

                setTimeout(() => {
                    this.quoteIndex =
                        this.quoteIndex === this.quotes.length - 1
                            ? 0
                            : this.quoteIndex + 1;

                    this.fade = false;
                }, 1000);
            }, time);
        }
    }
};
</script>

<style scoped lang="scss">
.navigation-grid {
    width: 100%;

    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: 1fr;
    grid-column-gap: 0;
    grid-row-gap: 0;

    @media screen and (max-width: 950px) {
        grid-template-columns: 1fr;
    }

    overflow: hidden;
}

.fade {
    transition: opacity 0.5s ease;
    opacity: 1;
}

.fade-in-out {
    opacity: 0;
}
</style>
